import { createFileRoute } from "@tanstack/react-router";
import { BabylonSceneWrapper } from "@/babylon/components/BabylonSceneWrapper";
import { PerformanceMonitor } from "@/pages/3d/live/PerformanceMonitor";

export const Route = createFileRoute("/demo/3d/live/performance")({
  component: () => (
    <BabylonSceneWrapper>
      <PerformanceMonitor />
    </BabylonSceneWrapper>
  ),
});
